/**
 *parses token authorities from COA server token
 * @param authorities
 * @returns {{}}
 */
export function tokenParser(authorities) {
  const parsedAuthorities = {};
  if (authorities) {
    // eslint-disable-next-line array-callback-return
    authorities[0].roles.map(() => {
      // if (role.role === Authorities.Admin || role.role === Authorities.Owner) {
      //     parsedAuthorities[role.role] = true;
      // } else {
      //     parsedAuthorities[role.role] = role.roleInfo.map((resourceSet)=> {
      //         return resourceSet.filter((resource)=>resource.name == 'Region')[0]
      // ? resourceSet.filter((resource)=>resource.name == 'Region')[0].value.toLowerCase()
      // : '';
      //     })
      // }
    });
  }
  return parsedAuthorities;
}

export function extractToken(response) {
  const token = response.access_token;
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace("-", "+").replace("_", "/");
  const output = JSON.parse(window.atob(base64));
  const { user_name: userName = null, authorities, mobile = null } = output;
  const cityIds = [];
  const agencyIds = [];
  const cityNames = [];
  const agencyNames = [];
  const operatorIds = [];
  const operatorNames = [];
  let role = "cityManager";
  if (authorities && authorities[0] && authorities[0].roles) {
    role = authorities[0].roles[0].role;
    const { roleInfo } = authorities[0].roles[0];
    roleInfo.forEach((row) => {
      row.forEach((ele) => {
        if (ele.name.toLowerCase() === "city") {
          cityNames.push(ele.value);
          cityIds.push(parseInt(ele.metaId, 10));
        }
        if (ele.name.toLowerCase() === "agency") {
          agencyNames.push(ele.value);
          agencyIds.push(ele && ele.metaId && ele.metaId.toString());
        }
        if (ele.name.toLowerCase() === "operator") {
          operatorNames.push(ele.value);
          operatorIds.push(ele && ele.metaId && ele.metaId.toString());
        }
      });
    });
  }
  return {
    email: userName || mobile,
    name: userName || mobile,
    role,
    cityIds,
    agencyIds,
    cityNames,
    agencyNames,
    operatorIds,
    operatorNames,
    token,
  };
}
